import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import {
  NO_LANE,
  NO_LANE_LABEL,
  laneChoiceLabel,
  laneValue,
  selectedLane,
  type MyShippingLane,
  type WarehouseShippingLane
} from '@/lib/shippingLane';
import './ShippingLaneSelect.scss';

interface ShippingLaneSelectProps {
  lanes: WarehouseShippingLane[];
  myLane?: MyShippingLane | null;
  saving?: boolean;
  onChange: (lane: WarehouseShippingLane | null) => void;
}

/** The lane the signed-in user is working at. Hidden when the company has no shipping lanes. */
const ShippingLaneSelect = ({ lanes, myLane, saving = false, onChange }: ShippingLaneSelectProps) => {
  if (!lanes.length) return null;
  const showLocation = new Set(lanes.map((lane) => lane.locationId)).size > 1;
  const current = selectedLane(lanes, myLane);
  const value = current ? laneValue(current) : NO_LANE;

  return (
    <label className="shipping-lane-select">
      <select
        aria-label="Shipping lane"
        value={value}
        disabled={saving}
        onChange={(event) => {
          const next = event.target.value;
          if (next === value) return;
          onChange(lanes.find((lane) => laneValue(lane) === next) ?? null);
        }}
      >
        <option value={NO_LANE}>{NO_LANE_LABEL}</option>
        {lanes.map((lane) => (
          <option key={laneValue(lane)} value={laneValue(lane)}>
            {laneChoiceLabel(lane, showLocation)}
          </option>
        ))}
      </select>
      <FiChevronDown aria-hidden="true" />
    </label>
  );
};

export default ShippingLaneSelect;
